import React from "react";

interface Props {
    active: boolean;
    count: number;
    label: string;
    onToggle: () => void;
}

const FilterToggleButton: React.FC<Props> = ({ active, count, label, onToggle }) => {
    return <button
            aria-pressed={active}
            className={`btn btn-sm ${active ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={onToggle}
            type="button"
        >
            {label}
            <span className={`badge ms-2 ${active ? "bg-white text-primary" : "bg-secondary bg-soft text-secondary"}`}>
                {count}
            </span>
        </button>;
};

export default FilterToggleButton;
